import VariantSelect from "@/pages/(app)/returns/refund/validate/variant-select";
import { cn } from "@/utils/cn";
import {
  ProductVariantDto,
  ReturnRequestLineItemDto,
} from "@babackapp/private-api-client/types";
import { ChevronDown, InfoIcon } from "lucide-react";
import { SimpleExchangeHoverCard } from "./simple-exchange-hover-card";

type ArticleItemVariantProps = {
  lineItem: ReturnRequestLineItemDto;
  editable?: boolean;
  onChange?: (variant: ProductVariantDto) => void;
};

export function ArticleItemVariant({
  lineItem,
  onChange,
  editable,
}: ArticleItemVariantProps) {
  const productId = lineItem.product.productId;
  const initialVariant = lineItem.variant;
  const newVariant = lineItem.new_variant;
  const variantUpdate =
    !!newVariant && newVariant.variant_id !== initialVariant.variant_id;

  const isExchange = lineItem.resolution === "exchange";

  return (
    <span className="inline-flex items-center gap-1">
      <VariantSelect
        productId={productId}
        onChange={onChange}
        editable={editable}
        lineItemId={lineItem.line_item_id}
      >
        <span
          className={cn(
            "underline-offset-2 inline-flex items-center gap-1",
            editable && "text-black font-medium",
          )}
        >
          <span
            className={cn(
              "truncate max-w-[180px]",
              variantUpdate && isExchange && "line-through",
            )}
          >
            {initialVariant.title}
          </span>
          {variantUpdate && isExchange && newVariant ? (
            <span className="truncate max-w-[180px]">
              {`→ ${[[newVariant.option1, newVariant.option2, newVariant.option3].filter(Boolean).join(" ")]}`}
            </span>
          ) : null}
          {editable && <ChevronDown className="size-3" />}
        </span>
      </VariantSelect>

      {isExchange && newVariant && variantUpdate && (
        <SimpleExchangeHoverCard
          initialVariant={initialVariant}
          newVariant={newVariant}
        >
          <InfoIcon className="size-3 text-muted-foreground" />
        </SimpleExchangeHoverCard>
      )}
    </span>
  );
}
